<div style="width:100%;">
    <form class="example-form">
        <mat-form-field class="field-full-width">
            <input type="text"
                    placeholder="Chercher un médicament"
                    aria-label="medicament"
                    matInput
                    [formControl]="drugSearchControl">
        </mat-form-field>
    </form>
</div>
<app-drug-table (selected)="select($event)" [drugs]="drugs"></app-drug-table>